import styles from './Banner.module.scss';
import { BannerProps } from './BannerProps';

import type { FC } from 'react';

export const Banner: FC<BannerProps> = ({
  bannerUrl,
  contentUrl,
  altText,
  customDataAttrGtmClick,
}) => (
  <a
    className={styles['styled-link']}
    href={contentUrl}
    data-gtm-click={customDataAttrGtmClick}
  >
    <img className={styles['styled-img']} src={bannerUrl} alt={altText} />
  </a>
);
